import { LoginPage } from '@agentic-flow-studio/shared/components/auth/LoginPage';
import { InboxClinicLogo } from '@agentic-flow-studio/shared/components/inbox-clinic-logo';
import { authClient } from '@/utils/betterAuth';

export default function Login() {
  return (
    <LoginPage
      brandName="Inbox Clinic"
      logo={<InboxClinicLogo className="h-7 w-7" />}
      app="clinic"
      authClient={authClient}
    />
  );
}
